import script from "./Competition.vue?vue&type=script&setup=true&lang=js"
export * from "./Competition.vue?vue&type=script&setup=true&lang=js"

import "./Competition.vue?vue&type=style&index=0&id=589b52dc&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589b52dc"]])

export default __exports__